<template>
  <qx-card title="业务说明">
    <section class="textBox">
      <p>1、账户余额：指车队可使用的油品供应商的金额，包括车队自己充值及油品供应商赠送的。</p>
      <p>2、有发票：</p>
      <p class="padLeft">（1）自己收油票：由油品供应商直接开票给车队。</p>
      <p class="padLeft">（2）抵扣运输专票：由油品供应商开票给票据平台，只能在开平台发票的订单中使用，用于使用油票抵扣运输专票的票点金额。</p>
      <p>3、无发票：分配优先级：供应商赠送油费>已经开票油费。</p>
      <p class="padLeft">（1）供应商赠送：油品供应商发放的返利。</p>
      <p class="padLeft">（2）已经开票：充值的抵扣运输专票的油金额，因业务撤销或转移，导致退回到车队账户的油费金额（ 例如：平台开票业务订单，做订单撤回，或者订单油金额转现，或者该订单司机平账等）。</p>
      <p>4、本车队定点油：本车队定点油站授信给车队，先使用后还款。</p>
      <p class="padLeft">（1）已用：车队分配给司机，司机加油的金额。车队还款成功后"已用"会释放该金额。</p>
    </section>
    <qx-card-form title="找油流程：">
      <section class="imgBox">
        <img class="introImg" src="~images/service/findOil.png" />
      </section>
    </qx-card-form>
    <qx-card-form title="本车队定点油流程：">
      <section class="imgBox">
        <img class="introImg" src="~images/service/siteOil.png" />
      </section>
    </qx-card-form>
  </qx-card>
</template>

<script>
export default {

};
</script>

<style scoped lang="scss">
.textBox{
  line-height: 28px;
  .padLeft{
    padding-left: 24px;
  }
}
.imgBox{
  padding: 24px;
  .introImg{
    width: 100%;
  }
}
</style>
